import store from '@/store'

const helpers = {
  hasSomePermission (list = []) {
    return list?.some((rp) => store.state.auth?.userAccount?.resource_access?.webapp?.roles?.some((p) => rp.includes(p)))
  },
  hasPermission (list = []) {
    return list?.every((l) => store.state.auth?.userAccount?.resource_access?.webapp?.roles?.some((v) => v === l))
  }
}

export default {
  install (Vue) {
    Vue.prototype.$helpers = helpers
  }
}
